import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './shop.actions';

@Injectable()
export class ShopEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadDealerShop$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerShop),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getShopContent(dealerSlug)).pipe(
                    switchMap((shop) => [actions.loadDealerShopSuccess({ shop })]),
                    catchError((error) => of(actions.loadDealerShopFailure({ error }))),
                ),
            ),
        );
    });
}
